import React, { useState } from 'react';
import { StarIcon } from 'lucide-react';
export function ReviewForm() {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  if (isSubmitted) {
    return <div className="bg-midnight-light border border-white/5 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-35">
        <div className="w-16 h-16 bg-teal-900/30 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-36">
          <span className="text-2xl" data-id="element-37">✨</span>
        </div>
        <h3 className="font-playfair text-2xl font-bold text-warmwhite mb-2" data-id="element-38">
          Thank you for sharing!
        </h3>
        <p className="font-inter text-softgray" data-id="element-39">
          Your experience helps other women know they aren't alone.
        </p>
      </div>;
  }
  return <div className="bg-midnight-light border border-white/5 rounded-2xl p-6 md:p-10 max-w-2xl mx-auto" data-id="element-40">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-41">
        <div className="flex flex-col items-center mb-8" data-id="element-42">
          <label className="font-inter text-sm text-softgray mb-3" data-id="element-43">
            Tap to rate your experience
          </label>
          <div className="flex gap-2" data-id="element-44">
            {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setRating(star)} onMouseEnter={() => setHoveredRating(star)} onMouseLeave={() => setHoveredRating(0)} className="focus:outline-none transition-transform hover:scale-110" data-id="element-45">
                <StarIcon className={`w-8 h-8 ${star <= (hoveredRating || rating) ? 'fill-rosegold text-rosegold' : 'fill-transparent text-white/20'} transition-colors`} data-id="element-46" />
              </button>)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-47">
          <div data-id="element-48">
            <input type="text" required placeholder="Your first name" className="w-full bg-midnight border border-white/10 rounded-lg px-4 py-3 font-inter text-warmwhite placeholder:text-white/20 focus:outline-none focus:border-rosegold/50 transition-colors" data-id="element-49" />
          </div>
          <div data-id="element-50">
            <input type="text" placeholder="Your city, state (optional)" className="w-full bg-midnight border border-white/10 rounded-lg px-4 py-3 font-inter text-warmwhite placeholder:text-white/20 focus:outline-none focus:border-rosegold/50 transition-colors" data-id="element-51" />
          </div>
        </div>

        <div data-id="element-52">
          <textarea required rows={4} placeholder="Tell us what happened the first time you used it..." className="w-full bg-midnight border border-white/10 rounded-lg px-4 py-3 font-inter text-warmwhite placeholder:text-white/20 focus:outline-none focus:border-rosegold/50 transition-colors resize-none" data-id="element-53" />
        </div>

        <div className="flex flex-col items-center pt-2" data-id="element-54">
          <button type="submit" className="w-full md:w-auto px-8 py-3 bg-rosegold hover:bg-rosegold-light text-midnight font-inter font-bold rounded-full transition-colors" data-id="element-55">
            Share My Experience →
          </button>
          <p className="font-inter text-xs text-softgray mt-4" data-id="element-56">
            Your review may be featured on this page.
          </p>
        </div>
      </form>
    </div>;
}